import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import NavBar from "../navbar/NavBar";
import Footer from "../footer/Footer";
import "./chinaCityDetailsStyle.css";
import { ChinaCity } from "../../data/chinaCity";
import { chinaMarathons } from "../../data/chinaMarathon";
import CAAlogo from "../../assets/icons/CAA-logo.png";

const ChinaCityDetails = () => {
  const { cityName } = useParams();
  const [CityData, setCityData] = useState(null);
  const [marathons, setMarathons] = useState([]);

  useEffect(() => {
    // 查找匹配的城市数据
    const foundCity = ChinaCity.find((city) => city.id === cityName);
    // 如果找到了城市数据(对象)，设置状态
    if (foundCity) {
      setCityData(foundCity);
      const marathonsList = chinaMarathons[cityName] || [];
      setMarathons(marathonsList);
    }
  }, [cityName]);

  return (
    <div>
      <NavBar />

      {/* 城市大标题 */}
      <div className="city-detail-container">
        <h1 className="city-name">{CityData?.name}</h1>
      </div>

      <div class name="marathon-card-header">
        {/* 城市马拉松内容 */}
        <div className="marathon-cards">
          {marathons.map((marathon) => (
            <Link
              to={`/china/${cityName}/${marathon.id}`}
              key={marathon.id}
              className="marathon-card"
            >
              <img
                src={marathon.image}
                alt={marathon.name}
                className="marathon-image"
              />
              <div className="marathon-info">
                <h2>{marathon.name}</h2>
                <p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ marginRight: "5px" }}
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                  {marathon.date}
                </p>
                {marathon.distance && <p>{marathon.distance}</p>}
                {marathon.isCAAcertified && (
                  <div className="caa-badge">
                    <img
                      src={CAAlogo}
                      alt="中国田协认证"
                      className="caa-logo"
                    />
                    中国田协认证赛事
                  </div>
                )}
              </div>
            </Link>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ChinaCityDetails;
